module.exports = __webpack_public_path__ + "1792395595471/fonts/WorkSans-Medium.d8f4a3a.woff2";